import { render, staticRenderFns } from "./Negativados.vue?vue&type=template&id=41765112&scoped=true"
import script from "./Negativados.vue?vue&type=script&lang=js"
export * from "./Negativados.vue?vue&type=script&lang=js"
import style0 from "./Negativados.vue?vue&type=style&index=0&id=41765112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41765112",
  null
  
)

export default component.exports